import React from 'react';
import notFound from '../assets/notFound.svg';
import { Button } from '../components';

const Error = () => {
  return (
    // flex flex-col  lg:flex-row  items-center justify-center
    <>
      <section className="section bg-gray-50 mt-24 grid">
        <div className="section-center grid lg:grid-cols-2  bg-gray-50">
          <div className="max-w-2xl grid place-content-center text-center border-b-2 lg:border-r-2 lg:border-b-0 pb-20 lg:pb-0">
            <h2 className="text-5xl md:text-7xl font-bold">404</h2>
            <p className="text-2xl md:text-4xl font-light">
              Sorry we couldn't find this page.{' '}
            </p>
            <p className="mb-8">
              But dont worry, you can find plenty of other things on our
              homepage.
            </p>
            <Button text="Back Home" link="/" color="green" />
          </div>
          <div className="max-w-2xl grid place-content-center">
            <div className="pt-20 lg:pt-0">
              <img src={notFound} alt="not found image" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Error;
